import styled from 'styled-components';
import { Stack } from '@karma/components';

export const Banner = styled.div`
  position: relative;
  border-radius: 12px;
  margin-bottom: 8px;
  overflow: hidden;
`;

export const Image = styled.img`
  height: 151px;
  width: 100%;
  object-fit: cover;
  filter: blur(6px);
`;

export const Logo = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 8px;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

export const ButtonsContainer = styled(Stack).attrs({
  spacing: 12,
  bMargin: 20,
})`
  & > * {
    width: 50%;
    max-width: initial;
    min-width: initial;
  }
`;
